import {UserSessionConstants} from './userSession.constants'
const {
    FETCHING_USER,
    FETCHING_USER_FAILURED,
    ESTABLISH_USER_SESSION,
    CLOSED_USER_SESSION
} = UserSessionConstants;

const defaultState = {
    user:null,
    confirmed:false,
    loading:false,
    error:null
}

 const UserSessionReducer = (state = defaultState , action) => {
    switch (action.type) {
        case FETCHING_USER:
            return{
                user:null,
                confirmed:true,
                loading:true
        };
        case FETCHING_USER_FAILURED:
            return{
                user:null,
                confirmed:true,
                loading:false,
                error:action.error
        };
        case ESTABLISH_USER_SESSION:
            return{
                user:action.user,
                confirmed:true,
                loading:false
            };    
        case CLOSED_USER_SESSION:
            return {
                user: null,
                confirmed: true,
                error:null
            };
        default:
        return state;
    }
};

export default UserSessionReducer;
